﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VXProxyUserV1Contract = void 0;
const ContractFacade_1 = require("./abstact/ContractFacade");
const VXProxyUserV1ABI_1 = require("./abi/VXProxyUserV1ABI");
class VXProxyUserV1Contract extends ContractFacade_1.ContractFacade {
    constructor(address, web3) {
        super(address, web3, VXProxyUserV1ABI_1.VXProxyUserV1ABI.GetABI());
    }
    // public rateUPLS:string;
    // public uPLSInStake:string;
    // public PLSToSwap:string;
    // public lastSplitTimestamp:string;
    // public swapRouterV2:string;
    // public swapPath:string[];
    // public swapMinPLSAmount:string;
    // public swapMaxPLSAmount:string;
    // public sendPLSIndex:string;
    // public sendPLSReceiver:string;
    // public bnsIndex:string;
    // public sendAddress:string;
    // public isBurnWithERC20Burn:boolean;
    getScope() {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this._call("scope");
            if (!result)
                return;
            result.rateUPLS = this._toDecimal(result.rateUPLS);
            result.uPLSInStake = this._toDecimal(result.uPLSInStake);
            result.PLSToSwap = this._toDecimal(result.PLSToSwap);
            result.lastSplitTimestamp = result.lastSplitTimestamp;
            result.swapMinPLSAmount = this._toDecimal(result.swapMinPLSAmount);
            result.swapMaxPLSAmount = this._toDecimal(result.swapMaxPLSAmount);
            result.sendPLSIndex = this._toDecimal(result.sendPLSIndex);
            result.bnsIndex = this._toDecimal(result.bnsIndex);
            return result;
        });
    }
    getScopeSwapPath() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this._call("getScopeSwapPath");
        });
    }
    withdraw_uPLS(uPLSAmountETH) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this._send('withdraw_uPLS', this._toWei(uPLSAmountETH));
            return result;
        });
    }
    withdraw_PLS() {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this._send('withdraw_PLS');
            return result;
        });
    }
}
exports.VXProxyUserV1Contract = VXProxyUserV1Contract;
//# sourceMappingURL=VXProxyUserV1Contract.js.map